import template from './branch_funding_source.edit.html';
import controller from './branch_funding_source.edit.controller';
import './branch_funding_source.edit.controller';

let branchFundingSourceeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default branchFundingSourceeditComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/edit/branch_funding_source.edit.component.js